import React, { Component } from 'react'
import { Row, Cell } from '../../../components/Table'
import { getMessage } from '../../../lib/translator'
import NewListingPage, {
  TABLE_ACTIONS,
} from '../../../containers/NewListingPage'
import campaignsEmpty from './images/campaigns_empty.svg'
import { DropDown, DropDownItem, ICONS } from '../../../components/DropDown'
import SWABannerLabelsForm from './Forms'
import './style.css'
import moment from 'moment'
import { Link } from 'react-router-dom'
import API from 'lib/api'
import { CAMPAIGN_LABELS_API } from 'config/app'
import AuthenticatedPage from 'containers/AuthenticatedPage'

const timeSwaBannersFormat = 'YYYY-MM-DD HH:mm'
const dateSwaBannersFormat = 'YYYY-MM-DD'
const emptySwaBannersState = {
  icon: campaignsEmpty,
  message: 'Currently there are no SWA Banners available',
  actions: /* istanbul ignore next */ ({ onAction }) => (
    <button
      className="primary button"
      onClick={() => {
        onAction(TABLE_ACTIONS.ADD)
      }}
    >
      + Add SWA Banner
    </button>
  ),
}

class SWABannersActions extends Component {
  render() {
    const { id, onAction, index } = this.props
    return (
      <React.Fragment>
        <DropDown icon={<img src={ICONS.VELLIP} alt="⋮" />}>
          <DropDownItem
            datakey={'delete' + index}
            onClick={() => onAction(TABLE_ACTIONS.DELETE, { id })}
          >
            {getMessage('search-campaigns.delete')}
          </DropDownItem>
        </DropDown>
      </React.Fragment>
    )
  }
}

const tableSWABannersProperties = () => {
  return {
    headers: ['ID', 'Status', 'Start DateTime', 'End DateTime', 'Action'],
    row: ({ id, startDate, endDate, onAction, index, isActiveSwaBanner }) => (
      <Row className={`${isActiveSwaBanner ? 'activeRow' : ''}`}>
        <Cell className="search-campaigns-campaignValidTill">
          <Link to={`/marketing/swa-banners/${id}`}>
            <span>{id}</span>
          </Link>
        </Cell>
        <Cell className="">
          <span>{isActiveSwaBanner ? 'Active Banner' : '-'}</span>
        </Cell>
        <Cell className="search-campaigns-campaignValidFrom">
          {startDate && moment(startDate).format(timeSwaBannersFormat)}
        </Cell>
        <Cell className="search-campaigns-campaignValidTill">
          {endDate && moment(endDate).format(timeSwaBannersFormat)}
        </Cell>
        <Cell className="search-campaigns-actions">
          <SWABannersActions onAction={onAction} id={id} index={index} />
        </Cell>
      </Row>
    ),
  }
}

class SWABanners extends Component {
  constructor(props) {
    super(props)
    this.state = {
      listing: {},
      syncing: false,
    }
    this.reloadSwaPublications = this.reloadSwaPublications.bind(this)
    this.pageReload = this.pageReload.bind(this)
  }

  async componentDidMount() {
    try {
      this.api = new API({ url: `${CAMPAIGN_LABELS_API}/v1/banner-config` })
      const dd = await this.api.get()
      /* istanbul ignore else */
      if (dd?.data) {
        this.setState({ listing: {
          ...dd.data,
          isActiveSwaBanner: true,
        } })
      } else {
        this.setState({
          listing: {
            dummyData: '',
          },
        })
      }
    } catch (err) {
      /* istanbul ignore next */
      console.log(err)
    }
  }

  componentWillUnmount() {
    this.api && this.api.cancel()
  }

  async reloadSwaPublications() {
    this.setState({ syncing: true })
    this.api = new API({ url: `${CAMPAIGN_LABELS_API}/v1/swa/publitas-sync` })
    const response = await this.api.get()

    if (response.code === 200) {
      this.setState({ syncing: false })
    }
  }

  pageReload(){
    window.location.reload()
  }
  render() {
    const { props } = this
    return (
      <>
        {Object.keys(this.state.listing).length > 0 ? (
          <NewListingPage
            testid="swa-banner-table"
            className="swa-banner-page"
            menu={props.menu}
            title="SWA Banners"
            api={{
              url: `${CAMPAIGN_LABELS_API}/v1/swa-banners/schedules`,
              transform: (response) => {
                /* istanbul ignore if  */
                if(Object.keys(this.state.listing).length > 1) {
                  const result = response.data?.schedules
                  result.unshift(this.state.listing)
                  return result
                } else {
                  return response.data?.schedules
                }
              },
            }}
            modalClassName={'swa-banners-popup'}
            emptyState={emptySwaBannersState}
            addHeading="Add SWA Banners"
            tableProperties={tableSWABannersProperties()}
            headerActions={({ onAction }) => (
              <div>
                <button
                  className="primary button vendor-btn"
                  onClick={() => {
                    onAction(TABLE_ACTIONS.ADD)
                  }}
                >
                  +{' '}
                  <span className="text" data-testid="add-swa-banner">
                    Add Banners
                  </span>
                </button>

                <button
                  className="primary button vendor-btn syncing-swa"
                  onClick={this.reloadSwaPublications}
                  disabled={this.state.syncing}
                >
                  <span className="text">
                    {this.state.syncing
                      ? 'Syncing....'
                      : 'Sync SWA Publications'}
                  </span>
                </button>
                <button
                  className="primary button vendor-btn syncing-swa"
                  onClick={this.pageReload}
                  title="This is to refresh the list whenever you add or delete any banner"
                >
                  <span className="text">Refresh Banner Page</span>
                </button>
              </div>
            )}
            filters={{
              forceShow: true,
              isSearchEnabled: true,
            }}
            form={{
              component: SWABannerLabelsForm,
              transformSubmit: /* istanbul ignore next */ (formData) => {
                const data = Object.assign({}, formData)

                const banners = []
                const val = data

                for (let i = 0; i < val.banners.length; i++) {
                  banners.push({
                    imageUrl: val[`logo-${i}`],
                    link: val[`name-${i}`],
                  })
                }

                data.start_datetime = data?.campaignStartTime
                  ? moment(
                      moment(data?.startDate).format(dateSwaBannersFormat) +
                        ` ${data?.campaignStartTime}`
                    ).format()
                  : moment(data?.startDate).format()
                if (data?.endDate) {
                  if (data?.campaignEndTime) {
                    data.end_datetime = moment(
                      moment(data?.endDate).format(dateSwaBannersFormat) +
                        ` ${data?.campaignEndTime}`
                    ).format()
                  } else {
                    data.end_datetime = moment(
                      moment(data?.endDate).format(dateSwaBannersFormat) +
                        ` 00:00`
                    ).format()
                  }
                }
                const { start_datetime, end_datetime } = data

                return {
                  data: [...banners],
                  startDate: start_datetime,
                  endDate: end_datetime,
                }
              },
            }}
          />
        ) : (
          <AuthenticatedPage
            menu={props.menu}
            from={props.location && props.location.pathname}
          >
            <div>Loading...</div>
          </AuthenticatedPage>
        )}
      </>
    )
  }
}

export default SWABanners
